import { Component, OnInit, Input, Output, ChangeDetectorRef } from '@angular/core';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { MatDialog } from '@angular/material/dialog';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-files-duplicate',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})
export class FilesComponentDuplicate implements OnInit {

  @Input() multiple;
  @Input() result;
  @Input() file_types;
  @Input() final;
  @Output() returnFiles = new EventEmitter();
  @Input() flag;
  @Input() file_length;
  active_files_length = 0;
  constructor(
    private dialog: MatDialog,
    private change_detector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.checkActiveFiles();


  }
  ngOnChanges() {

    setTimeout(() => {
      if (this.file_length) {
        this.active_files_length = this.file_length;
      }
    }
    )
  }
  ngAfterViewInit() {



  }
  fileChanged() {
  }

  removeFile() {


  }

  checkActiveFiles() {
    this.active_files_length = 0;
    if (this.result && this.result.length) {
      this.result.forEach(element => {
        if (element.status == 1) {
          this.active_files_length++;
        }
      });
    }
  }

  openModal() {
    const dialog = this.dialog.open(FileUploadComponent, {
      width: '300px',
      panelClass:"TM-Dialog",

      data: {
        result: JSON.parse(JSON.stringify(this.result || [])),
        multiple: this.multiple,
        file_types: this.file_types
      },
      disableClose: true
    });
    dialog.afterClosed().subscribe(res => {

      this.file_length = 0;
      this.result = JSON.parse(JSON.stringify(res || []));
      this.returnFiles.emit({ files: this.result, source: this.flag })
      // this.final = JSON.parse(JSON.stringify(res))
      this.checkActiveFiles();

      if (this.result && this.result[0] && this.result[0].status == 1) {
        this.file_length = 1;
      }
      this.filesComparsion();

      this.change_detector.detectChanges()
    })
  }
  result1: any = [];
  filesComparsion() {
    if (this.result.length == 1 && this.result[0].status == 1) {

      this.result = this.result[0];
    }
    else if (this.result.length != 1) {
      this.result = this.result.status = 0;

    }
  }

}
